// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"f54cf595","832":"dcebc918"}[chunkId] + ".chunk.js";
};